import Vue from 'vue';
export default Vue.extend({
    props: {
        opacity: { type: Number, default: 1 } // The opacity of the loading mask (0 to 1)
    },
    mounted() {
        // Set loader opacity based on the prop (default)
        document
            .getElementById('page-loader')
            .setAttribute('style', `opacity: ${this.opacity};`);
    }
});
